<main #mainElement class="w-full show">
	<lbca-input-text
		[disabled]="isDisabled"
		[editable]="isEditable"
		[tabeled]="isTabeled"
		[labeled]="!isLabeled"
		[require]="isRequired"
		[helperText]="helperTextValue"
		[label]="labelValue"
		(change)="changeEvent($event)"
		(click)="click()"
		(focusState)="setFocus($event)"
		(keyup)="inputKeyUpEvent($event)"
		[componetIconStyle]="componetIconStyle"
		[componetHelperIconStyle]="componetHelperIconStyle"
		[hasExternalError]="hasError"
		[value]="valueInput"
		autocomplete="off"
	></lbca-input-text>
</main>
<ng-template cdkPortal #templateAppend="cdkPortal">
	@if (!isLabeled || isTabeled || isEditable) {
		<div
			class="select-template"
			[ngClass]="{
				'bg-gray-100 cursor-not-allowed': isDisabled,
				'mt-[18px]': helperTextValue && helperTextValue !== '',
				'mt-[12px]': helperTextValue && helperTextValue === ''
			}"
			[ngStyle]="{
				width: bindProperties.width + 'px',
				height: loadingAnimation ? 32 : bindProperties.height + 16 + 'px'
			}"
		>
			@if (optionFiltered.length > 0 && !loadingAnimation) {
				<div class="overflow-y-scroll" [ngStyle]="{ height: bindProperties.height + 'px' }">
					@for (option of optionFiltered; track option) {
						<div class="st-margin">
							<div (mousedown)="selectOption($event, option)" class="st-option">
								{{ option.label }}
							</div>
						</div>
					}
				</div>
			}
			@if (optionFiltered.length === 0 && !loadingAnimation) {
				<span class="st-notfound">Não encontramos nenhum resultado.</span>
			}
			@if (loadingAnimation) {
				<div class="w-full h-[32px]"><lbca-loading-dropdown></lbca-loading-dropdown></div>
			}
		</div>
	}
</ng-template>
